export const dateFormat = [
    { value: 'AD', label: 'AD' },
    { value: 'BS', label: 'BS' },
]
